import { j as r } from "../../../node_modules/react/jsx-runtime.js";
import { memo as a } from "react";
const c = ({ width: s = 14, height: e = 14, class1: o, class2: t }) => /* @__PURE__ */ r.jsxs(
  "svg",
  {
    width: s,
    height: e,
    className: "h-6 w-6 animate-spin",
    viewBox: "0 0 100 100",
    children: [
      /* @__PURE__ */ r.jsx(
        "circle",
        {
          fill: "none",
          "stroke-width": "10",
          className: `stroke-current opacity-40 ${o}`,
          cx: "50",
          cy: "50",
          r: "40"
        }
      ),
      /* @__PURE__ */ r.jsx(
        "circle",
        {
          fill: "none",
          "stroke-width": "10",
          className: `stroke-current ${t}`,
          "stroke-dasharray": "250",
          "stroke-dashoffset": "210",
          cx: "50",
          cy: "50",
          r: "40"
        }
      )
    ]
  }
), l = a(c);
export {
  l as default
};
//# sourceMappingURL=Loader.js.map
